const u = (id, w = 1600) => `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80`;

export const DURATIONS = ["2N/3D", "3N/4D", "4N/5D", "5N/6D", "6N/7D"];
export const CATEGORIES = ["Budget", "Standard", "Premium", "Luxury", "Honeymoon", "Family"];
export const DEFAULT_WHATSAPP = "+919548340299";

export const IMG = {
  hero: u("1586359716568-3e1907e4cf9f", 2200),
  radhanagar: u("1599325601183-042bed55081c"),
  aerial: u("1638459032642-c658d3d888c0"),
  lagoon: u("1715940093974-8836926f3f41"),
  boat: u("1586053226626-febc8817962f"),
  jonboat: u("1545762374-d18079617da8"),
  coast: u("1658235163109-d16ce951dc1c"),
  rocky: u("1641719320002-743bc0384e0f"),
  jetty: u("1640618792277-b91f3199f6a8"),
  cellular: u("1721231564051-3b44b8058a9e"),
  honeymoon: u("1615966650071-855b15f29ad1"),
  family: u("1693020077268-1a3b572103c1"),
  luxury: u("1610641818989-c2051b5e2cfd"),
  scuba: u("1544551763-46a013bb70d5"),
  sunset: u("1579317292307-2a885f1cc968"),
  palm2: u("1506953823976-52e1fdc0149a"),
};

export const CATEGORY_INFO = {
  Budget: { img: IMG.jonboat, blurb: "Great-value stays, every must-see beach." },
  Standard: { img: IMG.boat, blurb: "Well-rated 3-star hotels, classic circuit." },
  Premium: { img: IMG.aerial, blurb: "4-star resorts and premium ferries." },
  Luxury: { img: IMG.luxury, blurb: "5-star resorts, private transfers." },
  Honeymoon: { img: IMG.honeymoon, blurb: "Candle-light dinners and sea-view rooms." },
  Family: { img: IMG.family, blurb: "Relaxed pace and kid-friendly beaches." },
};

export const DESTINATIONS = [
  { name: "Port Blair", note: "Cellular Jail, Corbyn's Cove & the Light and Sound Show", img: IMG.cellular },
  { name: "Havelock (Swaraj Dweep)", note: "Radhanagar & Elephant Beach, coral snorkelling", img: IMG.radhanagar },
  { name: "Neil (Shaheed Dweep)", note: "Natural Bridge, Bharatpur & Laxmanpur sunsets", img: IMG.boat },
  { name: "Baratang", note: "Mangrove creeks, limestone caves & mud volcano", img: IMG.coast },
  { name: "Ross & North Bay", note: "British-era ruins and glass-bottom coral rides", img: IMG.jetty },
];

export const ENQ_STATUSES = [
  { value: "new", label: "New Lead", cls: "bg-sky-100 text-sky-800 border-sky-200", bar: "bg-sky-500" },
  { value: "contacted", label: "Contacted", cls: "bg-amber-50 text-amber-800 border-amber-200", bar: "bg-amber-400" },
  { value: "follow_up", label: "Follow-up", cls: "bg-orange-50 text-orange-800 border-orange-200", bar: "bg-orange-500" },
  { value: "quoted", label: "Quotation Sent", cls: "bg-cyan-50 text-cyan-800 border-cyan-200", bar: "bg-cyan-500" },
  { value: "negotiation", label: "Negotiation", cls: "bg-indigo-50 text-indigo-800 border-indigo-200", bar: "bg-indigo-500" },
  { value: "booked", label: "Confirmed/Booked", cls: "bg-emerald-50 text-emerald-800 border-emerald-200", bar: "bg-emerald-500" },
  { value: "completed", label: "Completed", cls: "bg-teal-50 text-teal-800 border-teal-200", bar: "bg-teal-600" },
  { value: "lost", label: "Lost", cls: "bg-slate-100 text-slate-600 border-slate-200", bar: "bg-slate-400" },
];
export const CLOSED_STATUSES = ["booked", "completed", "lost"];

export const LEAD_DESTINATIONS = ["Port Blair", "Havelock (Swaraj Dweep)", "Neil Island (Shaheed Dweep)", "Baratang", "Ross Island",
  "North Bay", "North & Middle Andaman", "Complete Andaman tour", "Not sure yet"].map((v) => ({ value: v, label: v }));

export const BUDGETS = ["Under ₹15,000", "₹15,000-25,000", "₹25,000-40,000", "Above ₹40,000"].map((v) => ({ value: v, label: `${v} per person` }));

export const TRIP_TYPES = [
  { value: "Family", label: "Family package" },
  { value: "Honeymoon", label: "Honeymoon package" },
  { value: "Budget", label: "Budget package" },
  { value: "Standard", label: "Standard package" },
  { value: "Premium", label: "Premium package" },
  { value: "Luxury", label: "Luxury package" },
  { value: "Hotel", label: "Hotel booking" },
  { value: "Ferry", label: "Ferry booking" },
  { value: "Water activities", label: "Water activities" },
  { value: "Custom", label: "Custom trip / not sure" },
];
export const NON_PACKAGE_TRIPS = ["Hotel", "Ferry", "Water activities"];

export const LEAD_SOURCES = [
  { value: "website", label: "Website" },
  { value: "whatsapp", label: "WhatsApp" },
  { value: "instagram", label: "Instagram" },
  { value: "facebook", label: "Facebook" },
  { value: "google", label: "Google" },
  { value: "phone", label: "Phone call" },
  { value: "referral", label: "Referral" },
  { value: "other", label: "Other" },
];

export const LANDING_BY_CATEGORY = {
  Honeymoon: "/andaman-honeymoon-packages",
  Family: "/andaman-family-packages",
  Budget: "/andaman-budget-packages",
  Premium: "/andaman-premium-packages",
  Luxury: "/andaman-luxury-packages",
};

export const BOOKING_STATUSES = [
  { value: "confirmed", label: "Confirmed", cls: "bg-sky-100 text-sky-800 border-sky-200" },
  { value: "completed", label: "Completed", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  { value: "cancelled", label: "Cancelled", cls: "bg-rose-50 text-rose-700 border-rose-200" },
];

export const PAYMENT_MODES = ["UPI", "Bank Transfer", "Cash", "Card", "Cheque", "Other"];

export const COST_LABELS = {
  hotel: "Hotel accommodation",
  ferry: "Ferry tickets",
  transfers: "Transfers & vehicle",
  sightseeing: "Sightseeing & entry fees",
  other: "Permits & other services",
};
